import { Currency } from '@chiroup/components';

type Props = {
  treatmentName: string;
  subTotal: string | number;
  tax: number;
  total: number;
  payorsResponsibility?: { [key: string]: { name: string; amount: string } };
  patientResponsibility?: number;
  showResponsibility?: boolean;
  balance?: number;
  applyTax?: boolean;
  showTaxButton?: boolean;
  changeSalesTax?: () => void;
};
const EncounterBillingView: React.FC<Props> = ({
  treatmentName,
  subTotal,
  tax = 0,
  total = 0,
  payorsResponsibility,
  patientResponsibility,
  showResponsibility = false,
  balance,
  applyTax,
  showTaxButton,
  changeSalesTax,
}) => {
  return (
    <div className="border overflow-hidden rounded-md border-gray-300 border-spacing-4 p-4">
      <div className="pb-4 font-bold">{treatmentName ?? ''}</div>
      <div className="flex justify-between mb-2">
        <span>Subtotal:</span>
        <Currency value={subTotal} />
      </div>
      <div className="flex justify-between mb-2">
        <span>Tax:</span>

        {total > 0 && changeSalesTax && showTaxButton && (
          <div className="ml-4 sm:ml-64">
            <span
              onClick={() => changeSalesTax()}
              className="cursor-pointer text-primary-500 hover:text-primary-400 text-xs mr-8"
            >
              {applyTax ? 'Remove Tax' : 'Apply Tax'}
            </span>{' '}
          </div>
        )}

        <Currency value={tax} />
      </div>

      <div className="flex justify-between mb-2">
        <span>Total:</span>
        <Currency value={total} />
      </div>
      {showResponsibility && (
        <>
          <hr className="pb-2" />
          <div className="p-4 bg-gray-300 rounded-md dark:bg-darkGray-500">
            {Object.entries(payorsResponsibility ?? {})?.map(([key, value]) => (
              <div key={key} className="flex justify-between mb-2">
                <span>{value.name}:</span>
                <Currency value={value.amount} />
              </div>
            ))}
            <div className="flex justify-between mb-2 dark:bg-darkGray-500">
              <span>Patient Responsibility:</span>
              <Currency value={patientResponsibility} />
            </div>
          </div>
        </>
      )}
      {!!balance && (
        <div className="flex justify-between mb-2">
          <span>Balance:</span>
          <Currency value={balance} />
        </div>
      )}
    </div>
  );
};

export default EncounterBillingView;
